import { AfterViewInit, Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { configuration } from 'src/configuration';
import { SharedService } from '../service/shared.service';
import { ApiServiceService } from '../service/api-service.service';

@Component({
  selector: 'app-contacted-properties',
  templateUrl: './contacted-properties.component.html',
  styleUrls: ['./contacted-properties.component.css']
})
export class ContactedPropertiesComponent  {
  propertyList: any = [];
  limit: any = configuration.PAGE_LIMIT;
  offset: any = configuration.OFFSET;
  constructor(public shared: SharedService, private elRef: ElementRef, private renderer: Renderer2, public apiService: ApiServiceService) {
    this.shared.isWhiteMenu = true;
  }

  ngOnInit(): void {
    this.getPropertyList();
  }
  async getPropertyList() {
    let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.CONTACTED_PROPERTY_LIST, {
      limit: this.limit,
      offset: this.offset
    });
    if (res && !res.error && res.data) {
      this.propertyList = [];
      for(let t of res.data.rows) {
        if(t.contactedPropertyToPropertyData) {
          this.propertyList.push(t.contactedPropertyToPropertyData);
        }
      }
    }
  }
}
